import { Box, Flex, Text } from "@chakra-ui/react";
import React from "react";

interface AiInterviewerWizardStepperProps {
  currentStep: number;
  steps: { label: string }[];
}

const AiInterviewerWizardStepper: React.FC<AiInterviewerWizardStepperProps> = ({
  currentStep,
  steps,
}) => {
  return (
    <Flex direction="column" align="center" py="6">
      <Text
        fontSize="sm"
        fontWeight="semibold"
        color="whiteAlpha.600"
        textTransform="uppercase"
        mb="4"
      >
        New AI Interviewer
      </Text>
      <WizardStepper currentStep={currentStep} steps={steps} />
    </Flex>
  );
};

interface WizardStepperProps {
  currentStep: number;
  steps: { label: string }[];
}

const WizardStepper: React.FC<WizardStepperProps> = ({
  currentStep,
  steps,
}) => {
  const defaultProps = {
    borderColor: "whiteAlpha.800",
    bg: "transparent",
  };

  const activeProps = {
    borderColor: "white",
    bg: "white",
  };
  const completedProps = {
    borderColor: "whiteAlpha.500",
    bg: "whiteAlpha.500",
  };

  return (
    <Flex direction="column" align="center">
      {/* Circles and connecting lines row */}
      <Flex align="center">
        {steps.map((step, index) => {
          const isComplete = index < currentStep;
          const isActive = index === currentStep;
          const isLast = index === steps.length - 1;

          const stateProps = isActive
            ? activeProps
            : isComplete
            ? completedProps
            : defaultProps;

          return (
            <React.Fragment key={step.label}>
              {/* Circle */}
              <Box
                as="span"
                display="flex"
                alignItems="center"
                justifyContent="center"
                borderRadius="full"
                borderWidth="2px"
                w="4"
                h="4"
                flexShrink={0}
                transition="background 0.2s"
                {...stateProps}
              />
              {/* Line after circle (except last) */}
              {!isLast && (
                <Box
                  h="2px"
                  w="12"
                  bg={
                    isComplete
                      ? completedProps.borderColor
                      : defaultProps.borderColor
                  }
                />
              )}
            </React.Fragment>
          );
        })}
      </Flex>
      {/* Labels row - matching structure: circle width + line width */}
      <Flex align="flex-start" mt="1">
        {steps.map((step, index) => {
          const isComplete = index < currentStep;
          const isActive = index === currentStep;
          const isLast = index === steps.length - 1;

          const stateProps = isActive
            ? activeProps
            : isComplete
            ? completedProps
            : defaultProps;

          return (
            <React.Fragment key={step.label}>
              {/* Label centered on circle width */}
              <Box w="4" display="flex" justifyContent="center">
                <Text
                  fontSize="xs"
                  fontWeight="normal"
                  color={stateProps.borderColor}
                  whiteSpace="nowrap"
                >
                  {step.label}
                </Text>
              </Box>
              {/* Spacer matching line width (except last) */}
              {!isLast && <Box w="12" />}
            </React.Fragment>
          );
        })}
      </Flex>
    </Flex>
  );
};

export default AiInterviewerWizardStepper;
